import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export var fetchNext = createAction("".concat(reduxKey, "/FETCH_NEXT"), function (streamId) { return ({ streamId: streamId }); });
//# sourceMappingURL=actionCreators.js.map